<template>
    <div>
        <b-button variant="link" :size="sizeVariant" @click="download" :disabled="disabled" class="p-0">
            <b-icon icon="download" class="mr-2"/>
            <slot name="title">
                <span>Выгрузить</span>
            </slot>
        </b-button>
    </div>
</template>

<script>
    import { download } from "./download";

    export default {
        name: "DownloadButton",
        props: {
            url: { type: String },
            disabled: { type: Boolean },
            sizeVariant: { type: String, default: 'sm' }
        },
        methods: {
            download() {
                const vm = this;
                download(this.url).then(() => {
                    vm.$bvToast.toast('Выгрузка завершена', {title: 'Выгрузка документа', autoHideDelay: 5000, variant: 'success'})
                })
            }
        }
    }
</script>

<style scoped>

</style>